/**
 * URSH Luxury Theme - Common Header & Footer Component
 * Provides a single source of truth for the Header, Navigation, Mega Menu, 
 * Search Bar, Newsletter, and Footer across all preview pages.
 */

(function() {
  'use strict';

  // 1. HEADER HTML TEMPLATE
  function getHeaderHtml(isSolid) {
    const solidClass = isSolid ? ' ursh-header-wrapper--solid' : '';
    const solidStyle = isSolid ? ' style="margin-bottom: 0 !important;"' : '';

    return `
      <!-- 0. TOP BLACK ANNOUNCEMENT BAR -->
      <div class="ursh-announcement-bar" id="urshAnnouncementBar" style="background:#000000; color:#ffffff; width:100%; position:relative; z-index:200; display:block; padding:10px 44px; box-sizing:border-box; border-bottom:1px solid rgba(255,255,255,0.15);">
        <div class="ursh-announcement-bar__inner" style="display:flex; align-items:center; justify-content:center; position:relative; width:100%; min-height:20px;">
          <div class="ursh-announcement-bar__text" style="font-family:'DM Sans', sans-serif; font-size:12px; font-weight:500; letter-spacing:0.8px; color:#ffffff; text-align:center;">
            <span>Free shipping for all orders over $300.</span>
          </div>
          <button type="button" class="ursh-announcement-bar__close" id="urshAnnouncementClose" aria-label="Close Announcement" style="position:absolute; right:0; background:none; border:none; color:#ffffff; cursor:pointer; padding:4px 6px; display:inline-flex; align-items:center; justify-content:center;">
            <svg viewBox="0 0 24 24" width="17" height="17" stroke="currentColor" stroke-width="2" fill="none"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
      </div>

      <!-- 1. LUXURY HEADER -->
      <header class="ursh-header-wrapper${solidClass}" id="urshHeader"${solidStyle}>
        <div class="ursh-header-top">
          <div class="ursh-header-left">
          <button type="button" class="ursh-mobile-toggle" id="urshMobileToggle" aria-label="Open Navigation Menu">
            <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="1.6" fill="none"><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
          </button>
          <nav class="ursh-nav-row" aria-label="Main Navigation">
          <ul class="ursh-nav-list">

            <!-- 1. NEW ARRIVALS -->
            <li class="ursh-nav-item">
              <a href="preview-collection.html?cat=new-in" class="ursh-nav-link" data-nav="new-in">NEW ARRIVALS</a>
            </li>

            <!-- 2. ENGAGEMENT RINGS -->
            <li class="ursh-nav-item has-megamenu">
              <a href="preview-collection.html?cat=engagement-rings" class="ursh-nav-link" data-nav="engagement-rings">ENGAGEMENT RINGS</a>
              <div class="ursh-megamenu">
                <div class="ursh-megamenu__container">
                  <div class="ursh-megamenu__columns">
                    <div class="ursh-megamenu__col">
                      <ul class="ursh-megamenu__links">
                        <li><a href="preview-collection.html?cat=asscher-cut">Asscher Cut</a></li>
                        <li><a href="preview-collection.html?cat=cushion-cut">Cushion Cut</a></li>
                        <li><a href="preview-collection.html?cat=emerald-cut">Emerald Cut</a></li>
                        <li><a href="preview-collection.html?cat=marquise-cut">Marquise Cut</a></li>
                        <li><a href="preview-collection.html?cat=oval-cut">Oval Cut</a></li>
                        <li><a href="preview-collection.html?cat=pear-cut">Pear Cut</a></li>
                        <li><a href="preview-collection.html?cat=princess-cut">Princess Cut</a></li>
                        <li><a href="preview-collection.html?cat=radiant-cut">Radiant Cut</a></li>
                        <li><a href="preview-collection.html?cat=round-brillant-cut">Round Brillant Cut</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="ursh-megamenu__featured">
                    <a href="preview-collection.html?cat=engagement-rings" class="ursh-megamenu__card">
                      <img src="./assets/hero-jewelry.jpg" alt="Engagement Rings" class="ursh-megamenu__img">
                      <span class="ursh-megamenu__pill-btn">DISCOVER ENGAGEMENT RINGS</span>
                    </a>
                  </div>
                </div>
              </div>
            </li>

            <!-- 3. WHITE DIAMOND JEWELRY -->
            <li class="ursh-nav-item has-megamenu">
              <a href="preview-collection.html?cat=white-diamond" class="ursh-nav-link" data-nav="white-diamond">WHITE DIAMOND JEWELRY</a>
              <div class="ursh-megamenu">
                <div class="ursh-megamenu__container">
                  <div class="ursh-megamenu__columns">
                    <div class="ursh-megamenu__col">
                      <ul class="ursh-megamenu__links">
                        <li><a href="preview-collection.html?cat=rings">Rings</a></li>
                        <li><a href="preview-collection.html?cat=bracelet">Bracelet</a></li>
                        <li><a href="preview-collection.html?cat=necklace">Necklace</a></li>
                        <li><a href="preview-collection.html?cat=earrings">Earrings</a></li>
                        <li><a href="preview-collection.html?cat=wedding-bands">Wedding Bands</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="ursh-megamenu__featured">
                    <a href="preview-collection.html?cat=white-diamond" class="ursh-megamenu__card">
                      <img src="./assets/story-hero.jpg" alt="White Diamonds" class="ursh-megamenu__img">
                      <span class="ursh-megamenu__pill-btn">EXPLORE WHITE DIAMONDS</span>
                    </a>
                  </div>
                </div>
              </div>
            </li>

            <!-- 4. COLORED DIAMOND JEWELRY -->
            <li class="ursh-nav-item has-megamenu">
              <a href="preview-collection.html?cat=colored-diamond" class="ursh-nav-link" data-nav="colored-diamond">COLORED DIAMOND JEWELRY</a>
              <div class="ursh-megamenu">
                <div class="ursh-megamenu__container">
                  <div class="ursh-megamenu__columns">
                    <div class="ursh-megamenu__col">
                      <ul class="ursh-megamenu__links">
                        <li><a href="preview-collection.html?cat=colored-rings">Rings</a></li>
                        <li><a href="preview-collection.html?cat=colored-bracelet">Bracelet</a></li>
                        <li><a href="preview-collection.html?cat=colored-necklace">Necklace</a></li>
                        <li><a href="preview-collection.html?cat=colored-earrings">Earrings</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="ursh-megamenu__featured">
                    <a href="preview-collection.html?cat=colored-diamond" class="ursh-megamenu__card">
                      <img src="./assets/story-craftsmanship.jpg" alt="Colored Diamonds" class="ursh-megamenu__img">
                      <span class="ursh-megamenu__pill-btn">DISCOVER COLORED DIAMONDS</span>
                    </a>
                  </div>
                </div>
              </div>
            </li>

            <!-- 5. ABOUT US -->
            <li class="ursh-nav-item">
              <a href="preview-story.html" class="ursh-nav-link" data-nav="about">ABOUT US</a>
            </li>

          </ul>
        </nav>
        </div>

          <div class="ursh-brand-logo">
            <a href="preview-homepage.html" class="ursh-brand-logo__link" aria-label="URSH Homepage">
              <img src="./assets/ursh-logo.png" alt="URSH" class="ursh-brand-logo__img">
            </a>
          </div>

          <div class="ursh-header-icons">
            <a href="javascript:void(0)" class="ursh-header-icon" aria-label="Search" id="urshSearchTrigger">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="11" cy="11" r="7.5"/><line x1="16.5" y1="16.5" x2="21.5" y2="21.5"/></svg>
            </a>
            <a href="#wishlist" class="ursh-header-icon" aria-label="Wishlist">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            </a>
            <a href="preview-login.html" class="ursh-header-icon" aria-label="Account">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="12" cy="7.5" r="4"/><path d="M4 20.5c0-4 3.5-6.5 8-6.5s8 2.5 8 6.5"/></svg>
            </a>
            <a href="preview-cart.html" class="ursh-header-icon" aria-label="Shopping Bag">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="4.5" y="8.5" width="15" height="12.5" rx="2"/><path d="M8.5 10.5V6a3.5 3.5 0 0 1 7 0v4.5"/></svg>
              <span class="ursh-cart-badge">0</span>
            </a>
          </div>
        </div>

        

        <!-- Luxury Search Dim Backdrop -->
        <div class="ursh-search-backdrop" id="urshSearchBackdrop" onclick="window.toggleSearchBar && window.toggleSearchBar(event, false)"></div>

        <!-- Dropdown Search Bar & Luxury Results Panel -->
        <div class="ursh-search-bar" id="urshSearchBar">
          <div class="ursh-search-bar__header-row">
            <div class="ursh-search-bar__inner">
              <form class="ursh-search-bar__form" action="preview-collection.html" method="get" id="urshSearchForm" onsubmit="event.preventDefault(); window.location.href='preview-collection.html?q=' + encodeURIComponent(document.getElementById('urshSearchInput').value);">
                <span class="ursh-search-bar__icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="11" cy="11" r="7.5"/><line x1="16.5" y1="16.5" x2="21.5" y2="21.5"/></svg>
                </span>
                <input type="text" name="q" id="urshSearchInput" class="ursh-search-bar__input" placeholder="Search jewelry, diamonds, collections..." autocomplete="off">
                <button type="button" class="ursh-search-bar__close" id="urshSearchClose" onclick="window.toggleSearchBar && window.toggleSearchBar(event, false)" aria-label="Close search">
                  <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="1.6" fill="none"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </form>
            </div>
          </div>

          <div class="ursh-search-dropdown" id="urshSearchDropdown" style="display: none;">
            <div class="ursh-search-dropdown__inner">
              <div class="ursh-search-products-header">
                <h3 class="ursh-search-products-heading">Products</h3>
              </div>
              <div class="ursh-search-products__grid" id="urshSearchProductsGrid"></div>
              <div class="ursh-search-dropdown__footer">
                <a href="preview-collection.html" class="ursh-search-view-all-btn" id="urshSearchViewAllBtn">VIEW ALL RESULTS</a>
              </div>
            </div>
          </div>
        </div>
      
      <!-- LUXURY MOBILE DRAWER -->
      <div class="ursh-mobile-drawer" id="urshMobileDrawer" aria-hidden="true">
        <div class="ursh-mobile-drawer__overlay" id="urshMobileDrawerOverlay"></div>
        <div class="ursh-mobile-drawer__inner">
          <div class="ursh-mobile-drawer__header">
            <span class="ursh-mobile-drawer__title">URSH DIAMOND</span>
            <button type="button" class="ursh-mobile-drawer__close" id="urshMobileDrawerClose" aria-label="Close Menu">
              <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="1.6" fill="none"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
          <div class="ursh-mobile-drawer__body">
            <ul class="ursh-mobile-menu-list">
              <li class="ursh-mobile-menu-item">
                <a href="preview-collection.html?cat=new-in" class="ursh-mobile-menu-link">NEW ARRIVALS</a>
              </li>
              <li class="ursh-mobile-menu-item has-submenu">
                <div class="ursh-mobile-menu-row">
                  <a href="preview-collection.html?cat=engagement-rings" class="ursh-mobile-menu-link">ENGAGEMENT RINGS</a>
                  <button type="button" class="ursh-mobile-subtoggle" aria-label="Toggle Submenu">+</button>
                </div>
                <ul class="ursh-mobile-submenu">
                  <li><a href="preview-collection.html?cat=asscher-cut">Asscher Cut</a></li>
                  <li><a href="preview-collection.html?cat=cushion-cut">Cushion Cut</a></li>
                  <li><a href="preview-collection.html?cat=emerald-cut">Emerald Cut</a></li>
                  <li><a href="preview-collection.html?cat=marquise-cut">Marquise Cut</a></li>
                  <li><a href="preview-collection.html?cat=oval-cut">Oval Cut</a></li>
                  <li><a href="preview-collection.html?cat=pear-cut">Pear Cut</a></li>
                  <li><a href="preview-collection.html?cat=princess-cut">Princess Cut</a></li>
                  <li><a href="preview-collection.html?cat=radiant-cut">Radiant Cut</a></li>
                  <li><a href="preview-collection.html?cat=round-brillant-cut">Round Brillant Cut</a></li>
                </ul>
              </li>
              <li class="ursh-mobile-menu-item has-submenu">
                <div class="ursh-mobile-menu-row">
                  <a href="preview-collection.html?cat=white-diamond" class="ursh-mobile-menu-link">WHITE DIAMOND JEWELRY</a>
                  <button type="button" class="ursh-mobile-subtoggle" aria-label="Toggle Submenu">+</button>
                </div>
                <ul class="ursh-mobile-submenu">
                  <li><a href="preview-collection.html?cat=rings">Rings</a></li>
                  <li><a href="preview-collection.html?cat=necklaces">Necklaces & Pendants</a></li>
                  <li><a href="preview-collection.html?cat=earrings">Earrings</a></li>
                  <li><a href="preview-collection.html?cat=bracelets">Bracelets</a></li>
                  <li><a href="preview-collection.html?cat=bangles">Bangles</a></li>
                </ul>
              </li>
              <li class="ursh-mobile-menu-item has-submenu">
                <div class="ursh-mobile-menu-row">
                  <a href="preview-collection.html?cat=yellow-diamond" class="ursh-mobile-menu-link">YELLOW DIAMOND JEWELRY</a>
                  <button type="button" class="ursh-mobile-subtoggle" aria-label="Toggle Submenu">+</button>
                </div>
                <ul class="ursh-mobile-submenu">
                  <li><a href="preview-collection.html?cat=rings">Rings</a></li>
                  <li><a href="preview-collection.html?cat=necklaces">Necklaces & Pendants</a></li>
                  <li><a href="preview-collection.html?cat=earrings">Earrings</a></li>
                  <li><a href="preview-collection.html?cat=bracelets">Bracelets</a></li>
                  <li><a href="preview-collection.html?cat=bangles">Bangles</a></li>
                </ul>
              </li>
              <li class="ursh-mobile-menu-item">
                <a href="preview-collection.html?cat=high-jewelry" class="ursh-mobile-menu-link">HIGH JEWELRY</a>
              </li>
              <li class="ursh-mobile-menu-item">
                <a href="preview-collection.html?cat=perfumes" class="ursh-mobile-menu-link">HIGH PERFUMES</a>
              </li>
              <li class="ursh-mobile-menu-item">
                <a href="preview-about.html" class="ursh-mobile-menu-link">ABOUT URSH</a>
              </li>
            </ul>
            <div class="ursh-mobile-drawer__footer">
              <a href="preview-login.html" class="ursh-mobile-drawer__footer-link">Sign In / Account</a>
              <a href="#wishlist" class="ursh-mobile-drawer__footer-link">Wishlist</a>
              <a href="preview-contact.html" class="ursh-mobile-drawer__footer-link">Customer Service</a>
            </div>
          </div>
        </div>
      </div>

      </header>
    `;
  }

  // 2. FOOTER & NEWSLETTER HTML TEMPLATE
  function getFooterHtml() {
    return `
      <!-- SUBSCRIBE TO OUR NEWSLETTER -->
      <section class="luxury-newsletter-section" aria-label="Subscribe to our newsletter">
        <div class="luxury-newsletter-section__container">
          <h2 class="luxury-newsletter-section__title">SUBSCRIBE TO OUR NEWSLETTER</h2>

          <form class="luxury-newsletter-section__form" onsubmit="event.preventDefault(); alert('Thank you for subscribing to URSH!');">
            <!-- Row 1: First Name & Last Name -->
            <div class="luxury-newsletter-section__row luxury-newsletter-section__row--split">
              <input type="text" class="luxury-newsletter-section__input" placeholder="First Name" required>
              <input type="text" class="luxury-newsletter-section__input" placeholder="Last Name" required>
            </div>

            <!-- Row 2: Email address -->
            <div class="luxury-newsletter-section__row">
              <input type="email" class="luxury-newsletter-section__input" placeholder="Email address" required>
            </div>

            <!-- Consent & Privacy Disclaimer -->
            <div class="luxury-newsletter-section__disclaimer">
              <p class="luxury-newsletter-section__disclaimer-text">
                By registering, you consent to receive exclusive electronic communications from URSH Group and its affiliates. You may withdraw your consent at any time by clicking the unsubscribe link included in each of our communications.
              </p>
              <p class="luxury-newsletter-section__disclaimer-text">
                For further information on how your personal data is collected and processed, please refer to our <a href="#privacy" class="luxury-newsletter-section__privacy-link">Privacy Policy</a>
              </p>
            </div>

            <!-- Subscribe Button -->
            <div class="luxury-newsletter-section__submit-wrapper">
              <button type="submit" class="luxury-newsletter-section__btn">Subscribe</button>
            </div>
          </form>
        </div>
      </section>

      <!-- LUXURY BLACK FOOTER -->
      <footer class="luxury-footer" role="contentinfo">
        <div class="luxury-footer__container">

          <!-- Top Center Brand Logo -->
          <div class="luxury-footer__brand-top">
            <a href="preview-homepage.html" class="luxury-footer__brand-link" aria-label="URSH Homepage">
              <img src="./assets/ursh-logo-white.png" alt="URSH" class="luxury-footer__brand-logo-img">
            </a>
          </div>

          <!-- Main 5 Columns Grid -->
          <div class="luxury-footer__grid">

            <!-- Column 1: CONTACT US -->
            <div class="luxury-footer__col">
              <h4 class="luxury-footer__title">CONTACT US</h4>
              <div class="luxury-footer__contact-info">
                <a href="mailto:customerservice@urshdiamond.com" class="luxury-footer__contact-link">customerservice@urshdiamond.com</a>
                <a href="tel:+330155905963" class="luxury-footer__contact-link">+33 (0)1 55 90 59 63</a>
                <a href="#contact" class="luxury-footer__contact-btn">Contact us</a>
              </div>
            </div>

            <!-- Column 2: SHOP -->
            <div class="luxury-footer__col">
              <h4 class="luxury-footer__title">SHOP</h4>
              <ul class="luxury-footer__list">
                <li><a href="preview-collection.html?cat=all">All Jewelry</a></li>
                <li><a href="preview-collection.html?cat=gold">Gold</a></li>
                <li><a href="preview-collection.html?cat=diamond">Diamond</a></li>
                <li><a href="preview-collection.html?cat=silver">Silver</a></li>
                <li><a href="preview-collection.html?cat=rings">Rings</a></li>
                <li><a href="preview-collection.html?cat=earrings">Earrings</a></li>
                <li><a href="preview-collection.html?cat=necklaces">Necklaces</a></li>
                <li><a href="preview-collection.html?cat=bracelets">Bracelets</a></li>
              </ul>
            </div>

            <!-- Column 3: ABOUT -->
            <div class="luxury-footer__col">
              <h4 class="luxury-footer__title">ABOUT</h4>
              <ul class="luxury-footer__list">
                <li><a href="preview-story.html">Our Story</a></li>
                <li><a href="preview-story.html#craft">Craftsmanship</a></li>
                <li><a href="preview-story.html#materials">Materials</a></li>
                <li><a href="#journal">Journal</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            <!-- Column 4: HELP -->
            <div class="luxury-footer__col">
              <h4 class="luxury-footer__title">HELP</h4>
              <ul class="luxury-footer__list">
                <li><a href="#faq">FAQ</a></li>
                <li><a href="#shipping">Shipping</a></li>
                <li><a href="#returns">Returns</a></li>
                <li><a href="#size">Size Guide</a></li>
                <li><a href="#care">Jewelry Care</a></li>
              </ul>
            </div>

            <!-- Column 5: COUNTRY, LANGUAGE & PAYMENTS -->
            <div class="luxury-footer__col">
              <!-- Country Selector -->
              <div class="luxury-footer__select-box">
                <span class="luxury-footer__select-label">COUNTRY</span>
                <button type="button" class="luxury-footer__select-row" aria-label="Select Country">
                  <span class="luxury-footer__select-left">
                    <span class="luxury-footer__select-icon" style="font-size:14px;">🇮🇳</span>
                    <span>India</span>
                  </span>
                  <span class="luxury-footer__select-arrow">&rsaquo;</span>
                </button>
              </div>

              <!-- Language Selector -->
              <div class="luxury-footer__select-box">
                <span class="luxury-footer__select-label">LANGUAGE</span>
                <button type="button" class="luxury-footer__select-row" aria-label="Select Language">
                  <span class="luxury-footer__select-left">
                    <svg class="luxury-footer__select-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" style="width:13px;height:13px;"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                    <span>English</span>
                  </span>
                  <span class="luxury-footer__select-arrow">&rsaquo;</span>
                </button>
              </div>

              <!-- Payment Methods -->
              <div class="luxury-footer__payments">
                <div class="luxury-footer__payments-title">PAYMENT METHODS</div>
                <div class="luxury-footer__payment-icons">
                  <span class="luxury-pay-card" title="Visa">
                    <svg viewBox="0 0 36 24"><path fill="#1A1F71" d="M14.5 17.5h-2.3l1.4-9h2.3l-1.4 9zm8.9-8.8c-.5-.2-1.2-.4-2.1-.4-2.3 0-4 1.2-4 3 0 1.3 1.2 2 2.1 2.5.9.4 1.2.7 1.2 1.1 0 .6-.7.9-1.4.9-1 0-1.5-.1-2.3-.5l-.3-.2-.3 2c.6.3 1.7.5 2.8.5 2.5 0 4.1-1.2 4.1-3.1 0-1-.6-1.8-2-2.5-.8-.4-1.3-.7-1.3-1.1 0-.4.4-.8 1.3-.8.7 0 1.3.1 1.7.3l.2.1.3-1.9zm6.3 0h-1.8c-.6 0-1 .2-1.3.8l-3.6 8h2.4l.5-1.3h3l.3 1.3h2.1l-1.6-8.8zm-3.1 5.8l1.3-3.4.7 3.4h-2zm-18.7-5.8l-2.2 6.1-.2-1.2c-.4-1.3-1.6-2.8-3-3.5l2 7.4h2.4l3.6-8.8h-2.6z"/><path fill="#F7B600" d="M6.3 8.7h-4.2c-.3 0-.5.2-.6.4l-1.5 7.1 2.4-1.1s.4-1.5.5-1.9c.2-.8.8-1.5 1.7-1.5h1.7l-.4 2-1 5h2.4l3.6-8.8h-2.6l-1.4-1.2z"/></svg>
                  </span>
                  <span class="luxury-pay-card" title="Mastercard">
                    <svg viewBox="0 0 36 24"><circle cx="13" cy="12" r="7" fill="#EB001B"/><circle cx="23" cy="12" r="7" fill="#F79E1B"/><path fill="#FF5F00" d="M18 6.9a6.96 6.96 0 0 0-2.6 5.1c0 2 1 3.9 2.6 5.1 1.6-1.2 2.6-3.1 2.6-5.1 0-2-1-3.9-2.6-5.1z"/></svg>
                  </span>
                  <span class="luxury-pay-card" title="American Express">
                    <svg viewBox="0 0 36 24"><rect width="36" height="24" rx="2" fill="#006FCF"/><path fill="#ffffff" d="M4 16.5l3.2-9h3.6l3.2 9h-2.5l-.6-1.8H7.7l-.6 1.8H4zm4.2-3.6h2.2l-1.1-3.4-1.1 3.4zm7.8 3.6l-1.8-9h3.8l1.3 5.4 1.3-5.4h3.8l-1.8 9h-2.2l-1.1-4.8-1.1 4.8H16zm8.8 0v-9h6.4v2h-4.2v1.5h3.8v2h-3.8v1.5h4.2v2h-6.4z"/></svg>
                  </span>
                  <span class="luxury-pay-card" title="PayPal">
                    <svg viewBox="0 0 36 24"><path fill="#003087" d="M11 6.5h5.2c2.8 0 4.3 1.3 3.9 3.6-.5 2.7-2.3 3.9-4.8 3.9h-1.8l-1.1 6.5H9.6L11 6.5z"/><path fill="#0079C1" d="M14.5 9.5h4.8c2.4 0 3.8 1.1 3.4 3.2-.5 2.5-2.1 3.6-4.4 3.6h-1.6l-1 5.7h-2.4l1.2-12.5z"/></svg>
                  </span>
                  <span class="luxury-pay-card" title="Apple Pay">
                    <svg viewBox="0 0 36 24"><path fill="#000000" d="M10.8 10.6c-.3.4-.8.7-1.3.7-.1 0-.3 0-.4-.1-.1-.7.2-1.3.6-1.7.3-.4.8-.7 1.3-.7.1 0 .2.1.2.1 0 .6-.2 1.3-.4 1.7zm.4 1c-.7 0-1.3-.4-1.7-.4-.4 0-1 .4-1.6.4-.9 0-1.7-.5-2.1-1.3-.9-1.6-.2-4 1-4 .5 0 1 .3 1.3.3.3 0 .9-.4 1.6-.4.3 0 1.1.1 1.7.9-.1.1-.9.6-.9 1.7 0 1.3 1.1 1.8 1.2 1.8-.1.4-.4 1.3-.8 1.8-.5.7-.9 1.3-1.6 1.3l.9-3.1zm5.3.8h-1.5v4h-1.2V8.4h2.7c1.7 0 2.8 1.1 2.8 2.5 0 1.5-1.1 2.5-2.8 2.5zm0-3h-1.5v2h1.5c1 0 1.6-.6 1.6-1s-.6-1-1.6-1zm5.6 7v-1.1c-.4.8-1.2 1.2-2.1 1.2-1.4 0-2.3-1-2.3-2.3 0-1.4 1-2.3 2.5-2.3.6 0 1.2.1 1.6.4v-.4c0-.9-.6-1.4-1.6-1.4-.7 0-1.4.3-1.8.7l-.6-.8c.6-.6 1.5-.9 2.5-.9 1.7 0 2.7.9 2.7 2.4v4.5h-.9zm-1.8-1c.9 0 1.5-.6 1.5-1.4v-.6c-.3-.2-.8-.3-1.4-.3-1 0-1.6.5-1.6 1.3 0 .7.6 1 1.5 1zm4.8 3.5l1.6-4.5-2.5-6.5h1.3l1.8 5 1.8-5h1.3l-3.9 9.3c-.3.8-.8 1.2-1.6 1.2-.3 0-.5 0-.7-.1v-1c.2 0 .4.1.5.1.3 0 .6-.2.7-.6z"/></svg>
                  </span>
                </div>
              </div>
            </div>

          </div>

          <!-- Bottom Sub-Footer Bar -->
          <div class="luxury-footer__bottom-bar">
            <div class="luxury-footer__copyright">
              Copyright 2026 URSH all rights reserved
            </div>

            <div class="luxury-footer__legal-links">
              <a href="#terms" class="luxury-footer__legal-link">General Terms and Conditions</a>
              <a href="#privacy" class="luxury-footer__legal-link">URSH Group Data Privacy Notice</a>
            </div>

            <div class="luxury-footer__social-group">
              <a href="#facebook" class="luxury-footer__social-btn" aria-label="Facebook">
                <svg viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="#twitter" class="luxury-footer__social-btn" aria-label="X">
                <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="#instagram" class="luxury-footer__social-btn" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href="#pinterest" class="luxury-footer__social-btn" aria-label="Pinterest">
                <svg viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/></svg>
              </a>
              <a href="#youtube" class="luxury-footer__social-btn" aria-label="YouTube">
                <svg viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
              <a href="#tiktok" class="luxury-footer__social-btn" aria-label="TikTok">
                <svg viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.29 0 .58.04.85.12V9.36a6.33 6.33 0 0 0-.85-.06A6.34 6.34 0 0 0 3.14 15.6a6.34 6.34 0 0 0 10.82 4.48 6.3 6.3 0 0 0 1.86-4.48V8.71a8.28 8.28 0 0 0 4.77 1.52v-3.4c-.34 0-.68-.05-1-.14z"/></svg>
              </a>
              <a href="#linkedin" class="luxury-footer__social-btn" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
            </div>
          </div>

        </div>
      </footer>
    `;
  }

  // 3. INITIALIZE INTERACTIVE CONTROLLERS
  function initControllers() {
    // A. Sticky Header on Scroll
    function updateHeaderScroll() {
      const isScrolled = (window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0) > 5;
      const header = document.querySelector('.ursh-header-wrapper') || document.getElementById('urshHeader');
      if (header) {
        header.classList.toggle('is-scrolled', isScrolled);
      }
    }
    window.addEventListener('scroll', updateHeaderScroll, { passive: true });
    document.addEventListener('scroll', updateHeaderScroll, { passive: true });
    updateHeaderScroll();

    // B. Announcement Bar Close
    const annClose = document.getElementById('urshAnnouncementClose');
    if (annClose) {
      annClose.addEventListener('click', (e) => {
        if (typeof window.closeAnnouncementBar === 'function') {
          window.closeAnnouncementBar(e);
        } else {
          document.querySelectorAll('.ursh-announcement-bar, #urshAnnouncementBar').forEach(b => {
            b.classList.add('is-hidden');
            b.style.setProperty('display', 'none', 'important');
            const p = b.closest('.shopify-section, .announcement-bar-section');
            if (p) {
              p.classList.add('is-hidden');
              p.style.setProperty('display', 'none', 'important');
            }
          });
        }
      });
    }

    // C. Search Bar & Live Luxury Results Controller
    // On live Shopify, search is 100% dynamically driven by Shopify Predictive Search API in sections/header.liquid
    if (!window.Shopify && !window.__shopifySearchLive) {
      const SEARCH_PRODUCTS = [
        {
          id: 1,
          title: "Diamond Solitaire Ring",
          price: "€249.00",
          image: "./assets/prod-diamond-solitaire-ring.jpg",
          category: "Rings",
          keywords: ["ring", "rings", "diamond", "solitaire", "engagement", "white diamond", "luxury"]
        },
        {
          id: 2,
          title: "Pavé Halo Diamond Ring",
          price: "€199.00",
          image: "./assets/prod-halo-ring.jpg",
          category: "Rings",
          keywords: ["ring", "rings", "halo", "pave", "cushion", "diamond", "engagement"]
        },
        {
          id: 3,
          title: "Classic Tennis Diamond Bracelet",
          price: "€310.00",
          image: "./assets/prod-tennis-bracelet.jpg",
          category: "Bracelet",
          keywords: ["bracelet", "tennis", "diamond", "luxury", "gold"]
        },
        {
          id: 4,
          title: "Twisted Diamond Hoop Earrings",
          price: "€159.00",
          image: "./assets/prod-twist-earrings.jpg",
          category: "Earrings",
          keywords: ["earrings", "hoop", "diamond", "twisted"]
        },
        {
          id: 5,
          title: "Diamond Heart Pendant",
          price: "€179.00",
          image: "./assets/prod-heart-pendant.jpg",
          category: "Necklace",
          keywords: ["heart", "pendant", "necklace", "diamond"]
        },
        {
          id: 6,
          title: "Luxury Silver Necklace with Cross Pavé",
          price: "€139.00",
          image: "./assets/product-newin-1.png",
          category: "Necklace",
          keywords: ["necklace", "silver", "cross", "pave", "diamond"]
        }
      ];

      const DEFAULT_SUGGESTIONS = [
        "Diamond Rings",
        "Solitaire Engagement Ring",
        "Gold Necklace",
        "Tennis Bracelet",
        "Diamond Earrings",
        "Heart Pendant",
        "Halo Rings",
        "Colored Diamonds"
      ];

      function escapeSearchHtml(str) {
        return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }

      window.updateSearchDropdown = function(query) {
        const input = document.getElementById('urshSearchInput');
        const term = (typeof query === 'string' ? query : (input ? input.value : '')).trim();
        const dropdown = document.getElementById('urshSearchDropdown');
        const prodGrid = document.getElementById('urshSearchProductsGrid');
        const viewAllBtn = document.getElementById('urshSearchViewAllBtn') || document.getElementById('urshSearchViewAllLink');

        if (!dropdown || !prodGrid) return;

        // If no query is typed, keep dropdown completely hidden!
        if (!term) {
          dropdown.classList.remove('is-visible');
          dropdown.style.display = 'none';
          prodGrid.innerHTML = '';
          return;
        }

        // Show dropdown when user types
        dropdown.classList.add('is-visible');
        dropdown.style.display = 'block';

        if (viewAllBtn) {
          let vUrl = 'preview-collection.html?q=' + encodeURIComponent(term);
          if (window.location.search && window.location.search.indexOf('preview_theme_id') !== -1) {
            const previewParam = window.location.search.match(/preview_theme_id=[0-9]+/);
            if (previewParam) vUrl += '&' + previewParam[0];
          }
          viewAllBtn.href = vUrl;
        }

        // Filter Products according to typed text (strictly 4 products only)
        const termLower = term.toLowerCase();
        const matchedProds = SEARCH_PRODUCTS.filter(p => 
          p.title.toLowerCase().includes(termLower) ||
          (p.category && p.category.toLowerCase().includes(termLower)) ||
          (p.keywords && p.keywords.some(k => k.includes(termLower)))
        );

        if (matchedProds.length === 0) {
          prodGrid.innerHTML = '<div class="ursh-search-empty" style="grid-column: 1 / -1; padding: 40px 0; color: #777; font-size: 14px; text-align: center;">No products found matching "' + escapeSearchHtml(term) + '". Press Enter to view all results.</div>';
        } else {
          prodGrid.innerHTML = matchedProds.slice(0, 4).map(p => `
            <a href="preview-collection.html?q=${encodeURIComponent(p.title)}" class="ursh-search-card" data-handle="${escapeSearchHtml(p.title.toLowerCase().replace(/\\s+/g, '-'))}">
              <div class="ursh-search-card__image-box">
                <img src="${p.image}" alt="${escapeSearchHtml(p.title)}" class="ursh-search-card__img ursh-search-card__img--primary" loading="lazy">
              </div>
              <div class="ursh-search-card__info">
                <h4 class="ursh-search-card__title">${escapeSearchHtml(p.title)}</h4>
                <span class="ursh-search-card__price">${p.price}</span>
              </div>
            </a>
          `).join('');
        }

        // Reposition backdrop
        const bar = document.getElementById('urshSearchBar');
        const backdrop = document.getElementById('urshSearchBackdrop');
        if (bar && backdrop) {
          setTimeout(() => {
            const r = bar.getBoundingClientRect();
            if (r && r.bottom > 0) {
              backdrop.style.top = Math.round(r.bottom) + 'px';
              backdrop.style.height = (window.innerHeight - Math.round(r.bottom)) + 'px';
            }
          }, 40);
        }
      };

      window.selectSearchSuggestion = function(text) {
        let targetSearchUrl = 'preview-collection.html?q=' + encodeURIComponent(text);
        if (window.location.search && window.location.search.indexOf('preview_theme_id') !== -1) {
          const previewParam = window.location.search.match(/preview_theme_id=[0-9]+/);
          if (previewParam) targetSearchUrl += '&' + previewParam[0];
        }
        window.location.href = targetSearchUrl;
      };

      window.toggleSearchBar = function(e, forceState) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();

        const bar = document.getElementById('urshSearchBar');
        const input = document.getElementById('urshSearchInput');
        const header = document.getElementById('urshHeader') || document.querySelector('.ursh-header-wrapper');
        const backdrop = document.getElementById('urshSearchBackdrop');
        const dropdown = document.getElementById('urshSearchDropdown');

        if (!bar) return;

        const isCurrentlyOpen = bar.classList.contains('is-open') || bar.style.display === 'block';
        const shouldOpen = (typeof forceState === 'boolean') ? forceState : !isCurrentlyOpen;

        if (shouldOpen) {
          bar.classList.add('is-open');
          bar.style.display = 'block';
          if (header) header.classList.add('has-search-open');
          if (backdrop) {
            backdrop.style.display = 'block';
            const updateBackdropPos = () => {
              if (!bar) return;
              const r = bar.getBoundingClientRect();
              if (r && r.bottom > 0) {
                backdrop.style.top = Math.round(r.bottom) + 'px';
                backdrop.style.height = (window.innerHeight - Math.round(r.bottom)) + 'px';
              }
            };
            updateBackdropPos();
            requestAnimationFrame(updateBackdropPos);
            setTimeout(updateBackdropPos, 40);
            setTimeout(updateBackdropPos, 230);
          }
          if (dropdown) {
            dropdown.style.display = 'none';
            dropdown.classList.remove('is-visible');
          }
          if (input && input.value && input.value.trim() && window.updateSearchDropdown) {
            window.updateSearchDropdown(input.value);
          }
          setTimeout(() => {
            if (input) {
              input.focus();
            }
          }, 80);
        } else {
          bar.classList.remove('is-open');
          bar.style.display = 'none';
          if (backdrop) backdrop.style.display = 'none';
          if (header) header.classList.remove('has-search-open');
          if (input) input.value = '';
          if (dropdown) {
            dropdown.style.display = 'none';
            dropdown.classList.remove('is-visible');
          }
        }
      };

      const searchInput = document.getElementById('urshSearchInput');
      if (searchInput) {
        searchInput.addEventListener('input', function() {
          window.updateSearchDropdown(this.value);
        });
      }

      const searchTrigger = document.getElementById('urshSearchTrigger');
      if (searchTrigger) {
        searchTrigger.addEventListener('click', (e) => {
          window.toggleSearchBar(e);
        });
      }

      const searchClose = document.getElementById('urshSearchClose');
      if (searchClose) {
        searchClose.addEventListener('click', () => {
          window.toggleSearchBar(null, false);
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.keyCode === 27) {
          window.toggleSearchBar(null, false);
        }
      });
    }

    // D. Mega Menu Controller (Smooth Hover, Instant Close Everywhere Else)
    const allNavItems = document.querySelectorAll('.ursh-nav-item');
    const megamenuNavItems = document.querySelectorAll('.ursh-nav-item.has-megamenu');
    const headerWrapper = document.querySelector('.ursh-header-wrapper');

    function closeAllMegamenus() {
      megamenuNavItems.forEach(item => {
        item.classList.remove('is-open');
        item.classList.remove('is-force-closed');
      });
    }

    allNavItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        if (item.classList.contains('has-megamenu')) {
          megamenuNavItems.forEach(other => {
            if (other !== item) other.classList.remove('is-open');
          });
          item.classList.remove('is-force-closed');
          item.classList.add('is-open');
        } else {
          closeAllMegamenus();
        }
      });

      if (item.classList.contains('has-megamenu')) {
        item.addEventListener('mouseleave', (e) => {
          const toElement = e.relatedTarget;
          if (!toElement || (!item.contains(toElement) && !toElement.closest('.ursh-megamenu'))) {
            item.classList.remove('is-open');
          }
        });
      }
    });

    document.querySelectorAll('.ursh-megamenu').forEach(menu => {
      menu.addEventListener('mouseleave', (e) => {
        const toElement = e.relatedTarget;
        if (!toElement || !toElement.closest('.ursh-header-wrapper')) {
          closeAllMegamenus();
        }
      });
    });

    if (headerWrapper) {
      headerWrapper.addEventListener('mouseleave', (e) => {
        const toElement = e.relatedTarget;
        if (!toElement || (!toElement.closest('.ursh-header-wrapper') && !toElement.closest('.ursh-megamenu'))) {
          closeAllMegamenus();
        }
      });
    }

    // Close when cursor moves anywhere outside header and megamenu
    document.addEventListener('mousemove', (e) => {
      if (!e.target.closest('.ursh-header-wrapper') && !e.target.closest('.ursh-megamenu')) {
        const anyOpen = document.querySelector('.ursh-nav-item.has-megamenu.is-open');
        if (anyOpen) closeAllMegamenus();
      }
    }, { passive: true });

    // Close on page scroll
    window.addEventListener('scroll', () => {
      const anyOpen = document.querySelector('.ursh-nav-item.has-megamenu.is-open');
      if (anyOpen) closeAllMegamenus();
    }, { passive: true });

    // Close on link click
    document.querySelectorAll('.ursh-megamenu a, .ursh-nav-link').forEach(link => {
      link.addEventListener('click', () => {
        closeAllMegamenus();
      });
    });

    
    // Mobile Navigation Drawer Controllers
    const mobileToggle = document.getElementById('urshMobileToggle');
    const mobileDrawer = document.getElementById('urshMobileDrawer');
    const mobileClose = document.getElementById('urshMobileDrawerClose');
    const mobileOverlay = document.getElementById('urshMobileDrawerOverlay');

    function openMobileDrawer() {
      if (mobileDrawer) {
        mobileDrawer.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeMobileDrawer() {
      if (mobileDrawer) {
        mobileDrawer.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    }

    if (mobileToggle) mobileToggle.addEventListener('click', openMobileDrawer);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileDrawer);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileDrawer);

    // Mobile Submenu accordions
    window.urshToggleMobileSubmenu = function(el) {
      if (!el) return;
      const parentItem = el.closest('.has-submenu');
      if (!parentItem) return;
      const isOpen = parentItem.classList.toggle('is-open');
      const btn = parentItem.querySelector(':scope > .ursh-mobile-menu-row .ursh-mobile-subtoggle');
      if (btn) {
        btn.textContent = isOpen ? '−' : '+';
      }
    };

    document.querySelectorAll('.ursh-mobile-menu-row').forEach(row => {
      row.addEventListener('click', function(e) {
        if (row.closest('.has-submenu')) {
          e.preventDefault();
          e.stopPropagation();
          window.urshToggleMobileSubmenu(row);
        }
      });
    });

    // E. Active Link Highlighting
    const pathname = window.location.pathname.toLowerCase();
    const searchParams = new URLSearchParams(window.location.search);
    const catParam = searchParams.get('cat');

    if (pathname.includes('preview-story')) {
      const aboutLink = document.querySelector('.ursh-nav-link[data-nav="about"]');
      if (aboutLink) aboutLink.classList.add('is-active');
    } else if (catParam) {
      const activeLink = document.querySelector(`.ursh-nav-link[data-nav="${catParam}"]`);
      if (activeLink) activeLink.classList.add('is-active');
    }
  }

  // 4. MOUNTING FUNCTION
  function mount() {
    // Mount Header
    const headerContainer = document.getElementById('site-header') || document.querySelector('ursh-header');
    if (headerContainer && !headerContainer.dataset.rendered) {
      const isHomepage = window.location.pathname.toLowerCase().endsWith('preview-homepage.html') ||
                         window.location.pathname === '/' ||
                         document.getElementById('hero-banner') !== null;

      const forceSolid = headerContainer.getAttribute('data-variant') === 'solid' ||
                         headerContainer.classList.contains('is-solid') ||
                         !isHomepage;

      headerContainer.innerHTML = getHeaderHtml(forceSolid);
      headerContainer.dataset.rendered = 'true';
    }

    // Mount Footer
    const footerContainer = document.getElementById('site-footer') || document.querySelector('ursh-footer');
    if (footerContainer && !footerContainer.dataset.rendered) {
      footerContainer.innerHTML = getFooterHtml();
      footerContainer.dataset.rendered = 'true';
    }

    // Initialize interactive behaviors once header is present (works for both preview HTML & Shopify)
    if (!window._urshControllersInit && (document.querySelector('.ursh-header-wrapper') || (headerContainer && headerContainer.dataset.rendered))) {
      initControllers();
      window._urshControllersInit = true;
    }
  }

  // 1. Mount whatever DOM elements are ready right away
  mount();

  // 2. Always mount on DOMContentLoaded (captures elements lower in the HTML)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  }

  // 3. Failsafe on window load
  window.addEventListener('load', mount);

  // Expose global render function if needed dynamically
  window.UrshLayout = { mount: mount };
})();
